import * as React from 'react';

import ActResultApplicationContainer from '../../containers/ActResultApplication';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 実績申請画面
 * @param props
 */
const ActResultApplication: React.FC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('ActResultApplication_0047')} />
			<ActResultApplicationContainer {...props} />
		</>
	);
};

export default ActResultApplication;



// WEBPACK FOOTER //
// ./src/pages/personal/ActResultApplication.tsx